import React from 'react';
import '../../assets/css/shimmer.css'

const LoaderKnowledges = () => {
    // console.log(customerCm);

    return (
        <div className="knowledges shimmerBox d-flex">
            <div className='knowledge-div'>
                <div className="shine shimmerLine"></div>
            </div>
            <div className='knowledge-div'>
                <div className="shine shimmerLine"></div>
            </div>
            <div className='knowledge-div'>
                <div className="shine shimmerLine"></div>
            </div>
        </div>
    )
}
export default LoaderKnowledges;